import { render, staticRenderFns } from "./EquipmentDocument.vue?vue&type=template&id=ddb35366"
import script from "./EquipmentDocument.vue?vue&type=script&lang=js"
export * from "./EquipmentDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports